import React from 'react'
import CategoryForm from '../CategoryForm'
import { useSelector } from 'react-redux'
import questionSelectors from '../../../../../../store/selectors/question.selectors'
import { useCreateCategoryMutation, useFetchQuestionsQuery } from '../../../../../../store/apis/question.api'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'
import { fetchQuestionsSelectors } from '../../../../../../store/apis/utils/selectors/question.api.selectors'
import { useParams } from 'react-router'
import { COLORS } from '../../../../../../utils/colors.helper'
import { useVersionId } from '../../../../../../utils/parseURL.helper'
import { useAutoFocusFirstInput } from '../../../../../../../hooks/useAutoFocusFirstInput'

const useUnusedColorId = questionId => {
    const { token } = useParams()
    const versionId = useVersionId()
    const { data: question } = useFetchQuestionsQuery(
        { token, versionId },
        {
            selectFromResult: result => fetchQuestionsSelectors.byId({ id: questionId }, result),
        },
    )

    return COLORS.findIndex((_, index) =>
        question.categories.every(category => category.colorId % COLORS.length !== index),
    )
}

const CreateCategoryForm = ({ onSuccess }) => {
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)
    useAutoFocusFirstInput()

    const [createCategory, createCategoryResult] = useCreateCategoryMutation()
    const onSubmit = async values => {
        const response = await createCategory({ questionId: editingQuestionId, ...values })
        if ('data' in response) {
            openNotificationWithIcon('success', 'Category created successfully')
            onSuccess()
        }
    }

    const theFirstUnusedColor = useUnusedColorId(editingQuestionId)

    return (
        <CategoryForm
            onSubmit={onSubmit}
            error={createCategoryResult?.error}
            loading={createCategoryResult?.isLoading}
            actionName='Create'
            initialValues={{
                colorId: theFirstUnusedColor,
            }}
        />
    )
}

export default CreateCategoryForm
